import { useEffect, useRef } from "react";
import { useNodesInitialized } from "reactflow";

export function useAutoFocusElement<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  const nodesInitialized = useNodesInitialized();

  useEffect(() => {
    if (ref.current != null && nodesInitialized) {
      ref.current.focus();
    }
  }, [nodesInitialized]);

  return ref;
}
